import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  { title: "Sourcing", text: "Tell us what you want. We find the right car — the right spec, the right colours, the right seller." },
  { title: "Negotiation", text: "We handle every conversation with the dealer or seller and negotiate the price on your behalf." },
  { title: "Paperwork", text: "Contracts, financing documents and registration details are prepared and checked before you see them." },
  { title: "Shipping", text: "We organize transport so the car arrives where you need it, whether across town or across Canada." },
  { title: "Handover", text: "You receive one complete deal package. Sign, pay, and receive your car — nothing else required." },
];

export const Process = () => (
  <section id="process" data-testid="process-section" className="border-t border-hairline bg-paper py-24 md:py-36">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="grid grid-cols-1 gap-16 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Reveal>
            <Eyebrow>The process</Eyebrow>
            <h2 className="mt-6 font-display text-4xl font-light leading-tight tracking-tight md:text-5xl">
              From first conversation to keys in hand.
            </h2>
            <p className="mt-8 max-w-sm text-base leading-relaxed text-stone">
              Every step of a purchase that would normally take your evenings and weekends — handled quietly, from start to finish.
            </p>
          </Reveal>
        </div>
        <ol className="lg:col-span-7 lg:col-start-6">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.06}>
              <li data-testid={`process-step-${i + 1}`} className="grid grid-cols-[4rem_1fr] gap-6 border-t border-hairline py-10 md:grid-cols-[6rem_1fr]">
                <span className="font-display text-3xl font-light text-mist md:text-4xl">0{i + 1}</span>
                <div>
                  <h3 className="font-display text-2xl md:text-3xl">{s.title}</h3>
                  <p className="mt-3 max-w-md text-base leading-relaxed text-stone">{s.text}</p>
                </div>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </div>
  </section>
);
